import { render, staticRenderFns } from "./UserTicketDetailsView.vue?vue&type=template&id=e7ad2510"
import script from "./UserTicketDetailsView.vue?vue&type=script&lang=js"
export * from "./UserTicketDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports